export default __webpack_public_path__ + "static/media/notice_error.37e1cdf3.svg";